import { useState } from "react";
import { Form, Overlay, Popover } from "react-bootstrap";
import { IBaseItem } from "../types";
import "./SelectDropdownForm.css";
import { FormattedMessage } from "react-intl";

const SelectDropdownForm = (props: any) => {
  const { Elements } = props;

  const [showHelper, setShowHelper] = useState(false);
  const [targetHelper, setTargetHelper] = useState(null);

  const onControlChange = (e: any) => {
    if (props.SuscribedChange) props.SuscribedChange(e.target.value);
  };

  const handlerClickHelper = (e: any) => {
    setShowHelper(!showHelper);
    setTargetHelper(e.target);
  };

  return (
    <>
      <Form.Group
        className={`justify-content-center ${props.ClassGroup || ""}`}
      >
        <Form.Label className="font-label-form">
          <FormattedMessage
            id={props.Label || ""}
            defaultMessage={props.Label || ""}
          />
          {props.Helper ? (
            <>
              <img
                src={"img/questionmarkicon.png"}
                alt="questionmark"
                className="dashboard-questionmark-size"
                onClick={(e) => handlerClickHelper(e)}
              />
              <Overlay
                show={showHelper}
                target={targetHelper}
                placement={"right"}
              >
                <Popover>
                  <Popover.Body>{props.Helper || ""}</Popover.Body>
                </Popover>
              </Overlay>
            </>
          ) : (
            <></>
          )}
        </Form.Label>
        <Form.Select
          className={`${props.Classname ? props.Classname : ""}`}
          aria-label={`${props.AriaLabel ? props.AriaLabel : ""}`}
          onChange={(e: any) => onControlChange(e)}
          disabled={props.Disabled || false}
          defaultValue={props.DefaultValue || ""}
        >
          {props.IsLoading ? (
            <option value={0}></option>
          ) : (
            <>
              {props.OptionDefault ? <option value={0}></option> : null}
              {[].map.call(Elements, (element: IBaseItem, index: number) => {
                return (
                  <option
                    value={element.Id}
                    key={`select-common-${element.Id}`}
                  >
                    {element.Name}
                  </option>
                );
              })}
            </>
          )}
        </Form.Select>
      </Form.Group>
    </>
  );
};

export default SelectDropdownForm;
